import axios from "axios";

export default class AdminApi {

  constructor() {
    this.client = null;
    this.SERVER_URL = "https://api.yaongstore.com";
    // this.SERVER_URL = "https://dev-api.yaongstore.com";
    // this.SERVER_URL = "http://localhost:8080";
  }

  api = (options) => {
    let token = localStorage.getItem("ACCESS_TOKEN");
    let headers = {
      Accept: "application/json",
      withCredentials: false,
    };
    if (token && !options?.headers?.Authorization) {
      headers["Authorization"] = `Bearer ${token}`;
    }
    if (options?.contentType) {
      headers["Content-Type"] = options.contentType;
    }
    if (options?.headers?.Authorization) {
      headers["Authorization"] = options.headers.Authorization;
    }
    this.client = axios.create({
      baseURL: this.SERVER_URL,
      timeout: 60000,
      headers: headers
    });
    return this.client;
  };

  signIn = (username, password) => {
    return this.api().post("/auth/login-admin", {username: username, password: password})
      .then((res) => {
        return res?.data;
      }).catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  };

  refreshToken = (userNo, tokenInfo) => {
    return this.api({
      headers: {
        Authorization: `RefreshToken ${tokenInfo["refreshToken"]}`
      }}).get(`/auth/token/refresh?user_no=${userNo}`)
      .then((res) => {
        return res?.data;
      }).catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  getGameRoomList = (params) => {
    return this.api().get("/game/admin/rooms", {params: params})
      .then((res) => {
        return res?.data;
      }).catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  };

  createGameRoom = (params, file) => {
    let formData = new FormData();
    Object.keys(params).forEach((name) => {
      formData.append(name, params[name]);
    })
    if (file) formData.append("goodsImage", file);
    return this.api({contentType: 'multipart/form-data'}).post("/game/admin/rooms", formData)
      .then((res) => {
        if (res?.data?.result === "fail") {
          console.error(res?.data?.message);
        }
        return res;
      }).catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  };

  updateGameRoom = (params, file) => {
    let formData = new FormData();
    Object.keys(params).forEach((name) => {
      formData.append(name, params[name]);
    })
    if (file) formData.append("goodsImage", file);

    return this.api({contentType: 'multipart/form-data'}).patch("/game/admin/rooms", formData)
      .then((res) => {
        if (res?.data?.result === "fail") {
          console.error(res?.data?.message);
        }
        return res;
      }).catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  };

  deleteGameRoom = (roomId) => {
    return this.api().delete(`/game/admin/rooms?roomId=${roomId}`)
      .then((res) => {
        if (res?.data?.result === "fail") {
          console.error(res?.data?.message);
        }
        return res;
      }).catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  };


  getDeliveryInfoList = (params) => {
    return this.api().get("/delivery/admin/list", {params: params})
      .then((res) => {
        return res?.data;
      }).catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  };

  updateDeliveryStatus = (id) => {
    return this.api().patch("/delivery/admin/status", {deliveryId: id, deliveryStatus: "SENT"})
      .then((res) => {
        if (res?.data?.result === "fail") {
          console.error(res?.data?.message);
        }
        return res;
      }).catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  };

  getBookingList = (params) => {
    return this.api().get("/pool/admin/book", {params: params})
      .then((res) => {
        return res?.data;
      }).catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  };

  getBookingStats = () => {
    return this.api().get("/pool/admin/book/stats")
      .then((res) => {
        return res?.data;
      }).catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  };

  getPoolInfo = () => {
    return this.api().get("/pool/info")
      .then((res) => {
        return res?.data;
      }).catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  updatePoolInfo = (params) => {
    return this.api().patch("/pool/admin/info", {...params})
      .then((res) => {
        return res?.data;
      }).catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  getPoolHolidays = () => {
    return this.api().get("/pool/admin/holiday")
      .then((res) => {
        return res?.data;
      }).catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  addPoolHoliday = (holidayDate) => {
    return this.api().post("/pool/admin/holiday", {holidayDate})
      .then((res) => {
        return res?.data;
      }).catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  deletePoolHoliday = (holidayDate) => {
    return this.api().delete("/pool/admin/holiday", {params: {holidayDate}})
      .then((res) => {
        return res?.data;
      }).catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  addPoolPrice = (params) => {
    return this.api().post("/pool/admin/price", {...params})
      .then((res) => {
        return res?.data;
      }).catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }
  updatePoolPrice = (params) => {
    return this.api().patch("/pool/admin/price", {...params})
      .then((res) => {
        return res?.data;
      }).catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }
  deletePoolPrice = (id) => {
    return this.api().delete(`/pool/admin/price?poolPriceId=${id}`)
      .then((res) => {
        return res?.data;
      }).catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  updateBooking = (params) => {
    return this.api().patch("/pool/admin/book", {...params})
      .then((res) => {
        if (res?.data?.result === "fail") {
          console.error(res?.data?.message);
        }
        return res;
      }).catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  getEventList = (params) => {
    return this.api().get("/event/list", {params: params})
      .then((res) => {
        return res?.data;
      }).catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  createEvent = (params, file) => {
    let formData = new FormData();
    Object.keys(params).forEach((name) => {
      formData.append(name, params[name]);
    })
    if (file) formData.append("bannerImage", file);
    return this.api({contentType: 'multipart/form-data'}).post("/event/admin", formData)
      .then((res) => {
        if (res?.data?.result === "fail") {
          console.error(res?.data?.message);
        }
        return res;
      }).catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  };

  updateEventInfo = (params, file) => {
    let formData = new FormData();
    Object.keys(params).forEach((name) => {
      formData.append(name, params[name]);
    })
    if (file) formData.append("newBannerImage", file);
    return this.api({contentType: 'multipart/form-data'}).patch("/event/admin", formData)
      .then((res) => {
        return res?.data;
      }).catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  deleteEventInfo = (params) => {
    return this.api().delete(`/event/admin`, {params: params})
      .then((res) => {
        return res?.data;
      }).catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  sendPushMessage = (params) => {
    return this.api().post("/fcm/send", {...params})
      .then((res) => {
        return res;
      }).catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  getPushCampaigns = () => {
    return this.api().get("/push/admin/campaigns")
      .then((res) => res?.data)
      .catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  createPushCampaign = (params) => {
    return this.api().post("/push/admin/campaigns", params)
      .then((res) => res?.data)
      .catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  updatePushCampaign = (campaignCode, params) => {
    return this.api().patch(`/push/admin/campaigns/${campaignCode}`, params)
      .then((res) => res?.data)
      .catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  sendPushCampaign = (campaignCode, userNos) => {
    return this.api().post(`/push/admin/campaigns/${campaignCode}/send`, {userNos})
      .then((res) => res?.data)
      .catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  deletePushCampaign = (campaignCode) => {
    return this.api().delete(`/push/admin/campaigns/${campaignCode}`)
      .then((res) => res?.data)
      .catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  broadcastPushCampaign = (campaignCode) => {
    return this.api().post(`/push/admin/campaigns/${campaignCode}/broadcast`)
      .then((res) => res?.data)
      .catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  getPushBroadcastLogs = (campaignCode) => {
    return this.api().get(`/push/admin/campaigns/${campaignCode}/broadcast-logs`)
      .then((res) => res?.data)
      .catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  getPushDirectLogs = (campaignCode) => {
    return this.api().get(`/push/admin/campaigns/${campaignCode}/direct-logs`)
      .then((res) => res?.data)
      .catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  getConfig = () => {
    return this.api().get("/auth/config")
      .then((res) => {
        return res?.data;
      }).catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  getVersionLog = () => {
    return this.api().get("/auth/admin/version")
      .then((res) => {
        return res?.data;
      }).catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  updateConfig = (params) => {
    return this.api().patch("/auth/admin/version", {...params})
      .then((res) => {
        if (res?.data?.result === "fail") {
          console.error(res?.data?.message);
        }
        return res;
      }).catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  // 월드컵 예측 이벤트
  getWorldcupEvents = () => {
    return this.api().get("/worldcup/admin/events")
      .then((res) => res?.data)
      .catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  getWorldcupEvent = (eventId = 0) => {
    return this.api().get("/worldcup/admin/event", {params: {eventId}})
      .then((res) => res?.data)
      .catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  createWorldcupEvent = (params) => {
    return this.api().post("/worldcup/admin/event", params)
      .then((res) => res?.data)
      .catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  updateWorldcupEvent = (params) => {
    return this.api().patch("/worldcup/admin/event", params)
      .then((res) => res?.data)
      .catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  getWorldcupRounds = (eventId) => {
    return this.api().get("/worldcup/admin/rounds", {params: {eventId}})
      .then((res) => res?.data)
      .catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  updateWorldcupRoundStatus = (roundId, status) => {
    return this.api().patch(`/worldcup/admin/rounds/${roundId}/status`, null, {params: {status}})
      .then((res) => res?.data)
      .catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  getWorldcupTeams = (eventId) => {
    return this.api().get("/worldcup/admin/teams", {params: {eventId}})
      .then((res) => res?.data)
      .catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  createWorldcupTeam = (params) => {
    return this.api().post("/worldcup/admin/teams", params)
      .then((res) => res?.data)
      .catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  updateWorldcupTeam = (params) => {
    return this.api().patch("/worldcup/admin/teams", params)
      .then((res) => res?.data)
      .catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  getWorldcupMatches = (eventId, roundCode) => {
    return this.api().get("/worldcup/admin/matches", {params: {eventId, roundCode}})
      .then((res) => res?.data)
      .catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  createWorldcupMatch = (params) => {
    return this.api().post("/worldcup/admin/matches", params)
      .then((res) => res?.data)
      .catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  updateWorldcupMatch = (params) => {
    return this.api().patch("/worldcup/admin/matches", params)
      .then((res) => res?.data)
      .catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  settleWorldcupMatch = (matchId, params) => {
    return this.api().post(`/worldcup/admin/matches/${matchId}/settle`, params)
      .then((res) => res?.data)
      .catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  cancelWorldcupMatch = (matchId) => {
    return this.api().post(`/worldcup/admin/matches/${matchId}/cancel`)
      .then((res) => res?.data)
      .catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  getWorldcupMatchStats = (matchId) => {
    return this.api().get(`/worldcup/admin/matches/${matchId}/stats`)
      .then((res) => res?.data)
      .catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  // 사용자 관리
  getAdminUsers = (params) => {
    return this.api().get("/user/admin/users", {params})
      .then((res) => res?.data)
      .catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  getAdminUser = (userNo) => {
    return this.api().get(`/user/admin/users/${userNo}`)
      .then((res) => res?.data)
      .catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  getAdminUserPointHistory = (userNo, params) => {
    return this.api().get(`/user/admin/users/${userNo}/point/history`, {params})
      .then((res) => res?.data)
      .catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  getAdminUserSnackHistory = (userNo, params) => {
    return this.api().get(`/user/admin/users/${userNo}/snack/history`, {params})
      .then((res) => res?.data)
      .catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  getAdminUserCouponHistory = (userNo, params) => {
    return this.api().get(`/user/admin/users/${userNo}/coupon/history`, {params})
      .then((res) => res?.data)
      .catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  getAdminUserInvites = (userNo, params) => {
    return this.api().get(`/user/admin/users/${userNo}/invites`, {params})
      .then((res) => res?.data)
      .catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  getAdminInviteRanking = (params) => {
    return this.api().get("/user/admin/invite-ranking", {params})
      .then((res) => res?.data)
      .catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  getAdminYaongconBrands = () => {
    return this.api().get("/yaongcon/admin/brands")
      .then((res) => res?.data)
      .catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  getAdminYaongconGoods = (brandName = "전체") => {
    return this.api().get("/yaongcon/admin/goods", {params: {brandName}})
      .then((res) => res?.data)
      .catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  adminGrantYaongcon = (params) => {
    return this.api().post("/yaongcon/admin/grant", params)
      .then((res) => res?.data)
      .catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  adminGrantPoint = (userNo, params) => {
    return this.api().post(`/user/admin/users/${userNo}/point/grant`, params)
      .then((res) => res?.data)
      .catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  adminGrantSnack = (userNo, params) => {
    return this.api().post(`/user/admin/users/${userNo}/snack/grant`, params)
      .then((res) => res?.data)
      .catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }
}


export class KakaoApi {

  constructor() {
    this.client = null;
    this.authToken = "NGWzcT0Vx1d79Z3xLEDNxw=="; // API 호출 키
    this.serverName = "yaongmaster"; // API 호출 아이디
    this.SERVER_URL = "https://talkapi.lgcns.com/request/kakao.json";
  }

  api = () => {
    let headers = {
      Accept: "application/json",
      authToken: this.authToken,
      serverName: this.serverName,
      paymentType: "P"
    };
    this.client = axios.create({
      baseURL: this.SERVER_URL,
      timeout: 60000,
      headers: headers
    });
    return this.client;
  };

  // 예약 확정 알림 보내기
  sendBookingConfirmation = (date, phoneNumber, useTime, bedLocation) => {
    let params = {
      service: 2400103893,
      message: `[야옹상회]\n예약이 확정 되었어요. 그날 봐요!! \n예약 날짜 : ${date}\n이용 시간 : ${useTime}\n평상 번호 : ${bedLocation}\n▶︎ 주의 사항\n- 반짝이(글리터), 동물 튜브 및 120cm 이상 튜브 사용 금지\n- 병 반입 금지\n- 머리 덮는 모자 필수\n- 돗자리 필수\n- 신장 1미터 이하의 아동 및 영유아는 구명 조끼 필수 착용\n- 신장 150cm 이하 아동은 성인 풀장 이용 시 구명 조끼 착용 및 보호자 동반 필수\n- 미끄럼틀은 신장 110cm~150cm까지만 이용 가능\n▶︎고객센터\n수영장 예약관련 문의나 상담은 수영장 고객센터로 연락부탁드립니다. 야옹상회 고객센터는 수영장 관련 대응이 어렵습니다.\n수영장 이용 문의 : 010-2138-3563\n\n야옹상회 서비스 문의: 031-319-3087`,
      mobile: phoneNumber,
      template: "10011",
      title: "예약이 확정 되었어요!",
      buttons:[
        {name: "예약 확인하기", type: "WL", url_mobile: "https://app.yaongstore.com/pool/ticket"}
      ]
    }
    return this.api().post("/", {...params})
      .then((res) => {
        return res;
      }).catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  // 예약 취소 알림 보내기
  sendCancelConfirmation = (date, phoneNumber) => {
    let params = {
      service: 2400103893,
      message: `[야옹상회]\n신청 하신 ${date} 예약이 정상적으로 취소 되었어요.\n예약금은 매월 15일 / 말일에 일괄적으로 환불해 드려요.\n\n-수영장 고객센터: 010-2138-3563\n- 수영장 예약 관련 문의나 상담은 수영장 고객센터로 연락 부탁드립니다. 야옹상회 고객센터는 수영장 관련 대응이 어렵습니다.\n- 야옹상회 고객센터: 031-319-3087`,
      mobile: phoneNumber,
      template: "10007",
      title: "예약이 취소 되었어요!",
      buttons:[
        {name: "확인하기", type: "WL", url_mobile: "https://app.yaongstore.com/pool/ticket"}
      ]
    }
    return this.api().post("/", {...params})
      .then((res) => {
        return res;
      }).catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }

  // 상품 배송 알림 보내기
  sendDeliveryConfirmation = (username, nickname, phoneNumber) => {
    let params = {
      service: 2400103893,
      message: `[야옹상회]\n${username}(${nickname})님의 "토리를 구해줘" 우승 상품 배송이 시작 되었어요.\n\n- 고객센터: 031-319-3087`,
      mobile: phoneNumber,
      template: "10003",
      title: "토리를 구해줘 우승 상품 배송!",
      buttons:[
        {name: "야옹상회 바로가기", type: "WL", url_mobile: "https://app.yaongstore.com/playground"}
      ]
    }
    return this.api().post("/", {...params})
      .then((res) => {
        return res;
      }).catch((err) => {
        console.error(err.response?.data?.message ?? err);
      });
  }
}